import styled from 'styled-components';
import {colors, h2, mediaQueries} from '@/theme/lib';

export const StyledTodayAtZooListing = styled.section`
  margin-bottom: 5rem;
  .today-at-zoo-gridcontainer {
    gap: 1.5rem;
    ${mediaQueries.lg} {
      gap: 2rem;
    }
  }
`;

export const StyledResultsTitle = styled.h2`
  ${h2}
  font-family: ${(props) => props.theme.fonts.heading};
  font-weight: 600;
  color: ${(props) => props.theme.key === 'zsl' ? colors.white : colors.black };
  grid-column: 1 / span 5;

  ${mediaQueries.lg} {
    grid-column: 2 / span 8;
  }
`;

export const StyledResultWrapper = styled.div`
  grid-column: 1 / span 5;
  ${mediaQueries.lg} {
    grid-column: 2 / span 8;
  }
`;
